import i18n from "@/utils/i18n";
import { computed } from "vue";

const { t } = i18n.global;



// 访问地址处理
export function urlHandle(url) {
  let urlo =
    process.env.NODE_ENV === "production"
      ? window.g.BASE_API + url
      : "/api" + url;
  return urlo;
}
// 验证域名/ip
export function isIPAddress(hostname) {
  let enableExternal = sessionStorage.getItem("enableExternal");
  if (hostname === enableExternal) {
      // 针对部队 军网的判断 如果是军网就当做外网"21.156.179.208"
      return false;
  }
  let ipRegEx =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return ipRegEx.test(hostname);
}

// 判断浏览器环境，为手机端时跳转H5分享页
export function flag() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}
  
import { getExternalInfo } from "@/api/base.js";
// 验证域名/ip
export function getExternalInfoServer() {// 特殊私有化部署 处理
    getExternalInfo().then(res => {
      if(res.code == 1){
        let externalIp = res.data ? res.data.externalIp : "";
        sessionStorage.setItem('enableExternal', externalIp)
      }
    })
}




// 文件大小转换
export function filesizetoMB(size) {
    if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + "KB";
    } else if (size < 1024 * 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + "MB";
    } else {
        return (size / 1024 / 1024 / 1024).toFixed(2) + "GB";
    }
};





// 验证分屏类型 下是否有资源 回放 方法优化2025/05/15
export function screenDATA(urlData) {
  let videoType = [];// 分屏下拉
  let value1 = null;// 几分屏

  if (urlData.home && urlData.Teacher && urlData.Student) {
    // 都有地址
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      },
      {
        name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
        id: 2,
      },
      {
        name: computed(() => t('courseDetail.Triplescreendisplay')),// "三分屏",
        id: 3,
      },
    ];
    value1= 3; // 都有地址默认三分屏
  }else if (urlData.home && urlData.Teacher) {
    // 合成画面 和 老师画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      },
      {
        name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
        id: 2,
      }
    ];
    value1 = 1; 
  }else if(urlData.home && urlData.Student){
    // 合成画面 和 学生画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      },
      {
        name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
        id: 2,
      }
    ]
    value1 = 1; 
  }else if(urlData.Teacher && urlData.Student){
    // 老师画面 和 学生画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
        id: 2,
      }
    ]
    value1 = 2; 
  }else if(urlData.home){
    // 合成画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      }
    ]
    value1 = 1; 
  }else if(urlData.Teacher){
    // 老师画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      }
    ]
    value1 = 1; 
  }else if(urlData.Student){
    // 学生画面
    videoType = [
      {
        name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
        id: 1,
      }
    ]
    value1 = 1; 
  }
  // else if(urlData.Teacher || urlData.Student){
  //   // 老师画面 / 学生画面
  //   videoType = [
  //     {
  //       name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
  //       id: 2,
  //     },
  //   ]
  //   value1 = 2; 
  // }

  return {
    screenNULL: value1 ? true : false, // 隐藏下拉框
    selectScreen: videoType, // 分屏下拉数据
    screenNum: value1 // 几分屏
  }
  // let videoType = [];// 分屏下拉
  // let value1 = null;// 几分屏
  // let screenNULL = true;// 隐藏下拉框
  // if (urlData.home == "" && urlData.Teacher == "" && urlData.Student == "") {
  //   // 都没有地址
  //   screenNULL = false; // 隐藏下拉框
  //   value1 = null;
  //   videoType = [];
  // } else if (
  //   urlData.home !== "" &&
  //   urlData.Teacher !== "" &&
  //   urlData.Student !== ""
  // ) {
  //   // 都有地址
  //   videoType = [
  //     {
  //       name: computed(() => t('courseDetail.Oneminutescreen')),// "一分屏"
  //       id: 1,
  //     },
  //     {
  //       name: computed(() => t('courseDetail.Splitscreendisplay')),// "二分屏",
  //       id: 2,
  //     },
  //     {
  //       name: computed(() => t('courseDetail.Triplescreendisplay')),// "三分屏",
  //       id: 3,
  //     },
  //   ];
  //   value1= 3; // 都有地址默认三分屏
  // } else if (
  //   (urlData.home !== "" && urlData.Teacher !== "") ||
  //   (urlData.home !== "" && urlData.Student !== "")
  // ) {
  //   // 合成画面 和 老师/学生画面
  //   videoType = [
  //     {
  //       name: computed(() => t('courseDetail.Oneminutescreen')),
  //       id: 1,
  //     },
  //     {
  //       name: computed(() => t('courseDetail.Splitscreendisplay')),
  //       id: 2,
  //     }
  //   ];
  //   value1= 2;
  // } else if (urlData.Teacher == "" && urlData.Student == "") {
  //   // 老师画面 学生画面 没有 二分屏 和 三分屏
  //   videoType = [{
  //     name: computed(() => t('courseDetail.Oneminutescreen')),
  //     id: 1,
  //   }]
  //   value1= 1;
  // } else if (urlData.home == "") {
  //   // 合成画面为空 没有 一分屏 和 三分屏
  //   videoType = [{
  //     name: computed(() => t('courseDetail.Splitscreendisplay')),
  //     id: 2,
  //   }]
  //   value1= 2;
  // }  
  // return {
  //   screenNULL: screenNULL,
  //   selectScreen: videoType,
  //   screenNum: value1
  // }
}


// 验证当前资源分屏画面是否有回放资源 动态匹配分屏回放资源 决定最终画面排版
export function getScreenTypeArray(urlData) {
  const result = [];
  
  if (urlData.home) {
    result.push("YI");
  }
  
  if (urlData.Teacher) {
    result.push("ER");
  }
  
  if (urlData.Student) {
    result.push("SAN");
  }
  
  return result;
}


